import React from "react";
import { makeStyles, Grid, Card } from "@material-ui/core";
import Paymentdetail from "../../Views/app/payment/paymentdetail";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "99.5%",
    height: "100%",
  },
  btnstyle: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    marginTop: "2rem",
  },
  cardstyle: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    minHeight: "calc(100vh - 17.9rem)",
    maxHeight: "100%",
  },
  image: {
    width: "25rem",
    height: "auto",
  },
  gridcom: {
    height: "100%",
    width: "100%",
  },
  leftcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  rightCon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const Payment = () => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-start",
          }}
        >
          <Card className={classes.cardstyle}>
            <Grid container spacing={0} className={classes.gridcom}>
              <Grid item md={6} sm={12} xs={12} className={classes.leftcon}>
                <img
                  className={classes.image}
                  alt=""
                  src={require("../../images/graphic-icon/credit.png")}
                />
              </Grid>
              <Grid item md={6} sm={12} xs={12} className={classes.rightCon}>
                <Paymentdetail />
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Payment;
